import React from "react";
import { useSelector } from "react-redux";
import {
  setNestedPage,
  setNestedPageSize,
  setNestedParams,
  getActivityLog
} from "redux/crm/project/pifSlice";
import { useParams } from "react-router-dom";
import ActivityHistory from "components/common/ActivityHistory";

const PIFActivities = () => {
  const { project_id, building_id, adaptation_id, id } = useParams();

  const { activityLogData } = useSelector(state => state.crm_project_pif);

  return (
    <ActivityHistory
      activityLogData={activityLogData}
      setNestedPage={setNestedPage}
      setNestedPageSize={setNestedPageSize}
      setNestedParams={setNestedParams}
      getActivityLog={getActivityLog}
      projectId={project_id}
      buildingId={building_id}
      adaptationId={adaptation_id}
      pifId={id}
    />
  );
};

export default PIFActivities;
